import CmsModelState from '../_util/cms-model';

class CMSPostsState extends CmsModelState {
  get url() { return '/posts'; }
  get singular() { return 'post'; }
  get plural() { return 'posts'; }
  get extendParam() { return '_embed'; }
}

export default CMSPostsState;



// WEBPACK FOOTER //
// ./spa/state/cms/cms-posts.jsx